import React, { useEffect } from "react";
import { IoIosArrowRoundForward } from "react-icons/io";
import { HiOutlineShieldCheck } from "react-icons/hi2";
import { FaCheck } from "react-icons/fa6";
import { GoClock } from "react-icons/go";
import styles from "./thankyou.module.css";
import {
	STORAGE_KEY,
	useSurveyFormContext,
} from "../../../../context/survey-form-data/SurverFormContext";
import { Link } from "react-router-dom";
import confettiIcon from "../../../../images/headerimges/mis-survey/confetti.svg";
import aishaImage from "../../../../images/headerimges/mis-survey/aisha.svg";
import securedIcom from "../../../../images/headerimges/mis-survey/cloud-secured.svg";
import navigateIcon from "../../../../images/headerimges/mis-survey/navigator.svg";

const Thankyou = () => {
	const { dispatch: dispatchSurvey } = useSurveyFormContext();

	const endSurvey = () => {
		dispatchSurvey({ type: "CLEAR" });
		sessionStorage.removeItem("::dc::us-mis");
		sessionStorage.removeItem("::agent::us-mis");
		sessionStorage.removeItem("::channel::us-mis");
		sessionStorage.removeItem(STORAGE_KEY);
	};

	useEffect(() => {
		endSurvey();
		window.scrollTo({ top: 0, behavior: "smooth" });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<section className={styles.thankyou_container}>
			<img src={confettiIcon} alt="confetti" />

			<section className={styles.thankyou_other_section}>
				<h3>
					<HiOutlineShieldCheck /> About Us
				</h3>
				<p>
					At <span className={styles.highlight}>Sproxil</span>, we
					help protect lives by ensuring access to safe, authentic
					products. Our technology lets you verify medications and
					essential goods, preventing counterfeits.
				</p>

				<div className={styles.sproxil_usp}>
					<h3>
						<HiOutlineShieldCheck /> Stay Safe with{" "}
						<span className={styles.highlight}>Sproxil</span>!
					</h3>

					<p>
						<FaCheck />
						Verify your medicines instantly with our
						scratch-and-text authentication system
					</p>
					<p>
						<FaCheck />
						Shop with confidence knowing your health and safety are
						protected
					</p>
					<p>
						<FaCheck />
						Join millions of people who trust Sproxil for product
						verification and consumer protection!
					</p>
				</div>

				<Link to={"https://sproxil.com/about-us/"}>
					Learn more about Sproxil{" "}
					<IoIosArrowRoundForward color="white" size={24} />
				</Link>
			</section>

			<section className={styles.thankyou_other_section}>
				<img src={aishaImage} alt="aisha" />
				<h3>Got Questions About Medication?</h3>
				<p>AISHA has the answers—quick, reliable, and easy.</p>
				<Link to={"https://aisha.ng/"} target="_blank">
					Ask AISHA Now{" "}
					<IoIosArrowRoundForward color="white" size={24} />
				</Link>
				<div className={styles.aisha_usp}>
					<div>
						<GoClock />
						<p>24/7 Access</p>
					</div>
					<div>
						<img src={securedIcom} alt="secure and private" />
						<p>Secure & Private</p>
					</div>
					<div>
						<img src={navigateIcon} alt="expert guidance" />
						<p>Expert Guidance</p>
					</div>
				</div>
			</section>
		</section>
	);
};

export default Thankyou;
